import React, { useCallback, useMemo } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { TradingEntityClearingDetail, TradingEntityClearingType } from 'api'
import { AgGridWrapper, filteredColumnDefsBuilder } from 'view/components/datagrid'
import { ModalConsumerProps, withModal } from 'view/shared/modal'
import {
  directTradingEntityClearingPanelColumnDefs,
  DIRECT_PREFIX,
  tradingEntityClearingGridOptions,
  TradingEntityClearingPanelGridColumnId
} from './TradingEntityClearingPanelGridModel'
import { Locale, Translation } from 'locale'
import { getTradingEntityClearingDetailsByTradingEntityIdGetterSelector } from 'selectors/clearingSelectors'
import { ClearingGridHeader, Wrapper } from './TradingEntityClearingPanelStyled'

interface ViewTradingEntityDirectClearingPanelProps extends ModalConsumerProps {
  // Own Props
  tradingEntityId: string

  // State Props
  getTradingEntityClearingDetails: (
    tradingEntityId: string,
    tradingEntityClearingType: TradingEntityClearingType
  ) => TradingEntityClearingDetail[]
}

const mapStateToProps = createStructuredSelector({
  getTradingEntityClearingDetails: getTradingEntityClearingDetailsByTradingEntityIdGetterSelector
})

const ViewTradingEntityDirectClearingPanelComponent: React.FunctionComponent<ViewTradingEntityDirectClearingPanelProps> = props => {
  const { getTradingEntityClearingDetails, tradingEntityId } = props

  const gridData = getTradingEntityClearingDetails(tradingEntityId, TradingEntityClearingType.DIRECT)

  const noTradingEntityClearingsPlaceholder = useCallback(
    () => <div>{Locale.translate(Translation.SC_NO_TRADING_ENTITY_CLEARINGS)}</div>,
    []
  )

  const filteredColumnDefs = useMemo(
    () =>
      filteredColumnDefsBuilder(directTradingEntityClearingPanelColumnDefs)
        .without([`${DIRECT_PREFIX}${TradingEntityClearingPanelGridColumnId.CLEARING_RELATIONSHIP_ACTIONS}`])
        .build(),
    []
  )

  if (!gridData) {
    return null
  }

  return (
    <Wrapper>
      <ClearingGridHeader>
        <label>{Locale.translate(Translation.TC_DIRECT_TRADING_ENTITY_CLEARING)}</label>
      </ClearingGridHeader>
      <AgGridWrapper
        className="datagrid-borderless"
        gridOptions={tradingEntityClearingGridOptions}
        columnDefs={filteredColumnDefs}
        rowData={gridData}
        placeholder={noTradingEntityClearingsPlaceholder}
      />
    </Wrapper>
  )
}

export const ViewTradingEntityDirectClearingPanel = withModal(connect(mapStateToProps)(ViewTradingEntityDirectClearingPanelComponent))
